"use client";

import { useEffect, useState } from "react";
import AddComment from "../AddComment/AddComment";
import Comment from "../Comment";
import Prism from "prismjs";
import "prismjs/components/prism-jsx";
import "prismjs/plugins/toolbar/prism-toolbar.min.css";
import "prismjs/plugins/toolbar/prism-toolbar.min";
import "prismjs/plugins/copy-to-clipboard/prism-copy-to-clipboard.min";
import { Link } from "@/i18n/navigation";
import { useSession } from "next-auth/react";
import { useTranslations } from "next-intl";

export default function Comments({
    article,
    session: userSession = null,
    fetchSession = false,
}) {
    const { data: session, status } = useSession();
    const [comments, setComments] = useState([]);
    const t = useTranslations();

    const addComment = (comment) => {
        let tmpComments = [comment, ...comments];
        // Add new comment
        setComments(tmpComments);
    };

    useEffect(() => {
        let tmpComments = article.comments;

        // Filter comments if they have a value in parentComment
        tmpComments = tmpComments.filter((comment) => !comment.parentComment);

        tmpComments.sort((a, b) => {
            return new Date(b.creationDate) - new Date(a.creationDate);
        });
        setComments(tmpComments);

        Prism.highlightAll();
    }, []);

    return (
        <>
            {/* Title */}
            <div className="text-xl bold dark:text-white">
                {t("Comments_title")} ({comments.length})
            </div>

            {session ? (
                <AddComment article={article} addComment={addComment} />
            ) : (
                <div className="mt-1">
                    <p>
                        {t("Comments_shouldBeAuthToComment")}{" "}
                        <Link href="/login">
                            {t(
                                "Comments_shouldBeAuthToComment_login",
                            ).toLowerCase()}
                        </Link>{" "}
                        {t("Comments_shouldBeAuthToComment_or")}{" "}
                        <Link href="/signup">
                            {t(
                                "Comments_shouldBeAuthToComment_register",
                            ).toLowerCase()}
                        </Link>
                        .
                    </p>
                </div>
            )}

            {/* Comments */}
            <div className="flex flex-col gap-9 p-5">
                {comments.map((comment) => (
                    <div key={`c${comment.id}`}>
                        <Comment
                            comment={comment}
                            session={session}
                            article={article}
                        />
                    </div>
                ))}
            </div>
        </>
    );
}
